import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveFilter as _resolveFilter, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "row"
};
const _hoisted_2 = {
  class: "col-sm-6"
};
const _hoisted_3 = {
  class: "mb-3"
};
const _hoisted_4 = {
  class: "col-sm-6"
};
const _hoisted_5 = {
  class: "mb-3"
};
const _hoisted_6 = {
  class: "row"
};
const _hoisted_7 = {
  class: "col-sm-6"
};
const _hoisted_8 = {
  class: "mb-3"
};
const _hoisted_9 = {
  class: "col-sm-2"
};
const _hoisted_10 = {
  class: "mb-3"
};
const _hoisted_11 = {
  class: "col-sm-4"
};
const _hoisted_12 = {
  class: "mb-3"
};
const _hoisted_13 = {
  class: "form-check mt-4"
};
const _hoisted_14 = {
  style: {
    "text-align": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loading = _resolveComponent("Loading");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_b_form_input = _resolveComponent("b-form-input");
  const _component_b_input_group = _resolveComponent("b-input-group");
  const _component_b_icon = _resolveComponent("b-icon");
  const _component_b_input_group_text = _resolveComponent("b-input-group-text");
  const _component_b_input_group_append = _resolveComponent("b-input-group-append");
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback");
  const _component_b_form_select_option = _resolveComponent("b-form-select-option");
  const _component_b_form_select = _resolveComponent("b-form-select");
  const _component_b_form_group = _resolveComponent("b-form-group");
  const _component_AddressForm = _resolveComponent("AddressForm");
  const _component_b_card_text = _resolveComponent("b-card-text");
  const _component_b_card = _resolveComponent("b-card");
  const _component_b_button = _resolveComponent("b-button");
  const _component_b_card_header = _resolveComponent("b-card-header");
  const _component_DiscountCode = _resolveComponent("DiscountCode");
  const _component_BillingForm = _resolveComponent("BillingForm");
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
  const _component_Checkbox = _resolveComponent("Checkbox");
  const _component_vue_recaptcha = _resolveComponent("vue-recaptcha");
  const _component_b_form = _resolveComponent("b-form");
  const _component_b_container = _resolveComponent("b-container");
  const _filter_billingType = _resolveFilter("billingType");
  return _openBlock(), _createBlock(_component_b_container, {
    fluid: "",
    class: "subscribe-page"
  }, {
    default: _withCtx(() => [_createVNode(_component_Loading, {
      loading: _ctx.loading
    }, null, 8, ["loading"]), !_ctx.loading ? (_openBlock(), _createBlock(_component_b_form, {
      key: 0,
      onSubmit: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["prevent"]))
    }, {
      default: _withCtx(() => [_createVNode(_component_b_row, null, {
        default: _withCtx(() => [_createVNode(_component_b_col, null, {
          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createElementVNode("div", {
            class: "subscribe-hero"
          }, [_createElementVNode("h1", {
            class: "subscribe-title"
          }, "Subscribe"), _createElementVNode("p", {
            class: "subscribe-subtitle"
          }, " Create your account, choose your plan, and start watching live and on-demand content. ")], -1)]))], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      }), _createVNode(_component_b_row, {
        class: "my-4 mx-md-5 subscribe-section-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_col, {
          cols: "12"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_card, {
            header: "Personal Information",
            class: "subscribe-card"
          }, {
            default: _withCtx(() => [_createVNode(_component_b_card_text, null, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[24] || (_cache[24] = _createElementVNode("label", {
                class: "control-label",
                for: "firstname"
              }, "First Name *", -1)), _createVNode(_component_b_input_group, null, {
                default: _withCtx(() => [_createVNode(_component_b_form_input, {
                  type: "text",
                  modelValue: _ctx.account.user.firstname,
                  "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => _ctx.account.user.firstname = $event), $options.setBillingName],
                  modelModifiers: {
                    lazy: true
                  },
                  state: !_ctx.$v.account.user.firstname.$error,
                  onBlur: _cache[1] || (_cache[1] = $event => _ctx.$v.account.user.firstname.$touch()),
                  disabled: _ctx.loading,
                  placeholder: "First",
                  autocomplete: "given-name"
                }, null, 8, ["modelValue", "state", "onUpdate:modelValue", "disabled"])], undefined, true),
                _: 1
              })])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[25] || (_cache[25] = _createElementVNode("label", {
                class: "control-label",
                for: "lastname"
              }, "Last Name *", -1)), _createVNode(_component_b_input_group, null, {
                default: _withCtx(() => [_createVNode(_component_b_form_input, {
                  type: "text",
                  modelValue: _ctx.account.user.lastname,
                  "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => _ctx.account.user.lastname = $event), $options.setBillingName],
                  modelModifiers: {
                    lazy: true
                  },
                  state: !_ctx.$v.account.user.lastname.$error,
                  onBlur: _cache[3] || (_cache[3] = $event => _ctx.$v.account.user.lastname.$touch()),
                  disabled: _ctx.loading,
                  placeholder: "Last",
                  autocomplete: "family-name"
                }, null, 8, ["modelValue", "state", "onUpdate:modelValue", "disabled"])], undefined, true),
                _: 1
              })])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[27] || (_cache[27] = _createElementVNode("label", {
                class: "control-label",
                for: "email"
              }, "Email Address *", -1)), _createVNode(_component_b_input_group, null, {
                default: _withCtx(() => [_createVNode(_component_b_form_input, {
                  type: "email",
                  placeholder: "Email",
                  modelValue: _ctx.account.user.email,
                  "onUpdate:modelValue": [_cache[4] || (_cache[4] = $event => _ctx.account.user.email = $event), _cache[5] || (_cache[5] = $event => _ctx.$v.account.user.email.$touch())],
                  modelModifiers: {
                    lazy: true
                  },
                  state: !_ctx.$v.account.user.email.$error,
                  onBlur: _cache[6] || (_cache[6] = $event => _ctx.$v.account.user.email.$touch()),
                  disabled: _ctx.loading,
                  autocomplete: "email"
                }, null, 8, ["modelValue", "state", "disabled"]), _withDirectives(_createVNode(_component_b_input_group_append, null, {
                  default: _withCtx(() => [_createVNode(_component_b_input_group_text, null, {
                    default: _withCtx(() => [_createVNode(_component_b_icon, {
                      icon: "arrow-repeat",
                      animation: "spin"
                    })], undefined, true),
                    _: 1
                  })], undefined, true),
                  _: 1
                }, 512), [[_vShow, _ctx.searchEmail]]), !_ctx.$v.account.user.email.email.$invalid && !_ctx.$v.account.user.email.required.$invalid && _ctx.$v.account.user.email.isUnique.$invalid && !_ctx.$v.account.user.email.$pending ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, {
                  key: 0
                }, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode(" This email is taken ", -1)]))], undefined, true),
                  _: 1
                })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getErrors('user', 'email', ['email']), err => {
                  return _openBlock(), _createBlock(_component_b_form_invalid_feedback, {
                    key: err.id
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(err), 1)], undefined, true),
                    _: 2
                  }, 1024);
                }), 128))], undefined, true),
                _: 1
              })])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[30] || (_cache[30] = _createElementVNode("label", {
                class: "control-label",
                for: "countrycode"
              }, "Phone Country *", -1)), _createVNode(_component_b_form_group, null, {
                default: _withCtx(() => [_createVNode(_component_b_form_select, {
                  modelValue: _ctx.account.user.countrycode_id,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.account.user.countrycode_id = $event),
                  modelModifiers: {
                    lazy: true
                  },
                  options: $options.countryCodes,
                  disabled: _ctx.loading,
                  state: !_ctx.$v.account.user.countrycode_id.$error,
                  onBlur: _cache[8] || (_cache[8] = $event => _ctx.$v.account.user.countrycode_id.$touch()),
                  autocomplete: "tel-country-code"
                }, {
                  "text-field": _withCtx(() => [...(_cache[28] || (_cache[28] = []))]),
                  first: _withCtx(() => [_createVNode(_component_b_form_select_option, {
                    value: null,
                    disabled: ""
                  }, {
                    default: _withCtx(() => [...(_cache[29] || (_cache[29] = [_createTextVNode("Country Code", -1)]))], undefined, true),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["modelValue", "options", "disabled", "state"])], undefined, true),
                _: 1
              })])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_cache[31] || (_cache[31] = _createElementVNode("label", {
                class: "control-label",
                for: "phone"
              }, "Phone *", -1)), _createElementVNode("div", null, [_createVNode(_component_b_input_group, null, {
                default: _withCtx(() => [_createVNode(_component_b_form_input, {
                  type: "text",
                  name: "phone",
                  id: "phone",
                  placeholder: "Phone",
                  modelValue: _ctx.account.user.phone,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _ctx.account.user.phone = $event),
                  modelModifiers: {
                    lazy: true
                  },
                  state: !_ctx.$v.account.user.phone.$error,
                  onBlur: _cache[10] || (_cache[10] = $event => _ctx.$v.account.user.phone.$touch()),
                  disabled: _ctx.loading,
                  autocomplete: "tel-national"
                }, null, 8, ["modelValue", "state", "disabled"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getErrors('user', 'phone', ['cellPhone']), err => {
                  return _openBlock(), _createBlock(_component_b_form_invalid_feedback, {
                    key: err.id
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(err), 1)], undefined, true),
                    _: 2
                  }, 1024);
                }), 128))], undefined, true),
                _: 1
              })])])])]), _createVNode(_component_AddressForm, {
                countries: _ctx.countries,
                states: _ctx.states,
                onDataChange: $options.setUserAddress,
                "is-registration": ""
              }, null, 8, ["countries", "states", "onDataChange"])], undefined, true),
              _: 1
            })], undefined, true),
            _: 1
          })], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      }), _ctx.subscriptiontype ? (_openBlock(), _createBlock(_component_b_row, {
        key: 0,
        class: "my-4 mx-md-5"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_col, {
          cols: "12"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_card, {
            header: "Subscription Information",
            class: "subscribe-card"
          }, {
            default: _withCtx(() => [_createVNode(_component_b_card_text, null, {
              default: _withCtx(() => [_createVNode(_component_b_row, {
                class: "text-center"
              }, {
                default: _withCtx(() => [_createVNode(_component_b_col, {
                  cols: "12",
                  sm: "4"
                }, {
                  default: _withCtx(() => [_createElementVNode("h3", null, _toDisplayString(_ctx.subscriptiontype.name), 1), _createElementVNode("h2", null, _toDisplayString(_ctx.subscriptiontype.localcurrencyformatted), 1), _createElementVNode("div", null, _toDisplayString(_filter_billingType(_ctx.subscriptiontype.duration)), 1), _withDirectives(_createElementVNode("small", null, " * charges will be made in USD @ $" + _toDisplayString(_ctx.subscriptiontype.amount) + ", international fees may apply ", 513), [[_vShow, _ctx.subscriptiontype.localcurrency !== 'USD']]), _withDirectives(_createVNode(_component_b_button, {
                    variant: "danger",
                    onClick: _cache[11] || (_cache[11] = $event => $options.clearSubscriptionType())
                  }, {
                    default: _withCtx(() => [...(_cache[32] || (_cache[32] = [_createTextVNode("Choose a Different Type", -1)]))], undefined, true),
                    _: 1
                  }, 512), [[_vShow, _ctx.subscriptiontypes.length > 1]])], undefined, true),
                  _: 1
                }), _createVNode(_component_b_col, {
                  cols: "12",
                  sm: "8"
                }, {
                  default: _withCtx(() => [_createElementVNode("p", null, [_cache[33] || (_cache[33] = _createElementVNode("i", null, "Subscription Terms", -1)), _createTextVNode(": " + _toDisplayString(_ctx.subscriptiontype.terms) + " ", 1), _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)), _withDirectives(_createElementVNode("b", null, " ** subscription will auto renew until you cancel. ", 512), [[_vShow, _ctx.subscriptiontype.duration]])])], undefined, true),
                  _: 1
                })], undefined, true),
                _: 1
              })], undefined, true),
              _: 1
            })], undefined, true),
            _: 1
          })], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      })) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_b_row, {
        class: "my-4 mx-md-5 subscription-selection"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_col, {
          cols: "12"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_row, {
            class: "align-self-stretch"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscriptiontypes, t => {
              return _openBlock(), _createBlock(_component_b_col, {
                key: t.id,
                class: "text-center"
              }, {
                default: _withCtx(() => [_createVNode(_component_b_card, {
                  onClick: $event => $options.selectSubType(t),
                  class: _normalizeClass(["h-100 px-0 subscribe-plan-card", {
                    selected: _ctx.account.subscriptiontype_id === t.id
                  }])
                }, {
                  default: _withCtx(() => [_createVNode(_component_b_card_header, {
                    class: "bg-success text-white"
                  }, {
                    default: _withCtx(() => [_createElementVNode("h3", null, _toDisplayString(t.name), 1)], undefined, true),
                    _: 2
                  }, 1024), _createVNode(_component_b_card_text, {
                    class: "p-3"
                  }, {
                    default: _withCtx(() => [_createElementVNode("h2", null, _toDisplayString(t.localcurrencyformatted), 1), _createElementVNode("div", null, _toDisplayString(_filter_billingType(t.duration)), 1), _withDirectives(_createElementVNode("small", null, " * charges will be made in USD @ $" + _toDisplayString(t.amount) + ", international fees may apply ", 513), [[_vShow, t.localcurrency !== 'USD']]), _createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(t.description), 1)])], undefined, true),
                    _: 2
                  }, 1024)], undefined, true),
                  _: 2
                }, 1032, ["onClick", "class"])], undefined, true),
                _: 2
              }, 1024);
            }), 128))], undefined, true),
            _: 1
          })], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      }, 512), [[_vShow, _ctx.account.subscriptiontype_id == null]]), _ctx.account.subscriptiontype_id ? (_openBlock(), _createBlock(_component_b_row, {
        key: 1,
        class: "my-4 mx-md-5"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_col, {
          cols: "12"
        }, {
          default: _withCtx(() => [_createVNode(_component_DiscountCode, {
            discount: _ctx.account.discount,
            subscriptiontype_id: +_ctx.account.subscriptiontype_id,
            onDiscountApplied: $options.applyDiscount,
            color: "none"
          }, null, 8, ["discount", "subscriptiontype_id", "onDiscountApplied"])], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      })) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_b_row, {
        class: "my-4 mx-md-5"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_col, {
          cols: "12"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_card, {
            header: "Billing Information",
            class: "subscribe-card"
          }, {
            default: _withCtx(() => [_createVNode(_component_b_card_text, null, {
              default: _withCtx(() => [_createVNode(_component_b_row, null, {
                default: _withCtx(() => [_ctx.subscriptiontype ? (_openBlock(), _createBlock(_component_b_col, {
                  key: 0,
                  cols: "12"
                }, {
                  default: _withCtx(() => [_createElementVNode("h3", null, "Amount Due: " + _toDisplayString($options.amountDueFormatted), 1)], undefined, true),
                  _: 1
                })) : _createCommentVNode("", true)], undefined, true),
                _: 1
              }), _createVNode(_component_BillingForm, {
                states: _ctx.states,
                countries: _ctx.countries,
                name: _ctx.billingName,
                "is-registration": true,
                onUpdate: $options.setBilling
              }, null, 8, ["states", "countries", "name", "onUpdate"])], undefined, true),
              _: 1
            })], undefined, true),
            _: 1
          })], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      }, 512), [[_vShow, _ctx.account.subscriptiontype_id && $options.amountDue > 0]]), _createVNode(_component_b_row, {
        class: "my-4 mx-md-5 subscribe-section-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_col, {
          cols: "12"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_card, {
            header: "User Account Information",
            class: "subscribe-card"
          }, {
            default: _withCtx(() => [_createVNode(_component_b_card_text, null, {
              default: _withCtx(() => [_createVNode(_component_b_row, null, {
                default: _withCtx(() => [_createVNode(_component_b_col, {
                  cols: "12",
                  sm: "4"
                }, {
                  default: _withCtx(() => [_createVNode(_component_b_form_group, null, {
                    default: _withCtx(() => [_cache[36] || (_cache[36] = _createElementVNode("label", {
                      class: "control-label"
                    }, "User Name * (5 minimum)", -1)), _createVNode(_component_b_input_group, null, {
                      default: _withCtx(() => [_createVNode(_component_b_form_input, {
                        type: "text",
                        modelValue: _ctx.account.user.username,
                        "onUpdate:modelValue": [_cache[12] || (_cache[12] = $event => _ctx.account.user.username = $event), _cache[14] || (_cache[14] = $event => _ctx.$v.account.user.username.$touch())],
                        modelModifiers: {
                          lazy: true
                        },
                        state: !_ctx.$v.account.user.username.$error,
                        onBlur: _cache[13] || (_cache[13] = $event => _ctx.$v.account.user.username.$touch()),
                        disabled: _ctx.searchUsername,
                        minlength: "5",
                        placeholder: "Desired Username",
                        autocomplete: "username"
                      }, null, 8, ["modelValue", "state", "disabled"]), _ctx.searchUsername ? (_openBlock(), _createBlock(_component_b_input_group_append, {
                        key: 0
                      }, {
                        default: _withCtx(() => [_createVNode(_component_b_input_group_text, null, {
                          default: _withCtx(() => [_createVNode(_component_b_icon, {
                            icon: "arrow-repeat",
                            animation: "spin"
                          })], undefined, true),
                          _: 1
                        })], undefined, true),
                        _: 1
                      })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getErrors('user', 'username', ['minLength']), err => {
                        return _openBlock(), _createBlock(_component_b_form_invalid_feedback, {
                          key: err.id
                        }, {
                          default: _withCtx(() => [_createTextVNode(_toDisplayString(err), 1)], undefined, true),
                          _: 2
                        }, 1024);
                      }), 128)), !_ctx.$v.account.user.username.required.$invalid && !_ctx.$v.account.user.username.minLength.$invalid && _ctx.$v.account.user.username.isUnique.$invalid && !_ctx.$v.account.user.username.$pending ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, {
                        key: 1
                      }, {
                        default: _withCtx(() => [...(_cache[35] || (_cache[35] = [_createTextVNode(" Username is taken ", -1)]))], undefined, true),
                        _: 1
                      })) : _createCommentVNode("", true)], undefined, true),
                      _: 1
                    })], undefined, true),
                    _: 1
                  })], undefined, true),
                  _: 1
                }), _createVNode(_component_b_col, {
                  cols: "12",
                  sm: "4"
                }, {
                  default: _withCtx(() => [_createVNode(_component_b_form_group, null, {
                    default: _withCtx(() => [_cache[37] || (_cache[37] = _createElementVNode("label", {
                      class: "control-label"
                    }, "Password *", -1)), _createVNode(_component_b_input_group, null, {
                      default: _withCtx(() => [_createVNode(_component_b_form_input, {
                        type: "password",
                        modelValue: _ctx.account.user.password,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _ctx.account.user.password = $event),
                        modelModifiers: {
                          lazy: true
                        },
                        state: !_ctx.$v.account.user.password.$error,
                        onBlur: _cache[16] || (_cache[16] = $event => _ctx.$v.account.user.password.$touch()),
                        required: "",
                        minlength: "6",
                        placeholder: "New Password",
                        autocomplete: "new-password"
                      }, null, 8, ["modelValue", "state"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getErrors('user', 'password', ['minLength']), err => {
                        return _openBlock(), _createBlock(_component_b_form_invalid_feedback, {
                          key: err.id
                        }, {
                          default: _withCtx(() => [_createTextVNode(_toDisplayString(err), 1)], undefined, true),
                          _: 2
                        }, 1024);
                      }), 128))], undefined, true),
                      _: 1
                    })], undefined, true),
                    _: 1
                  })], undefined, true),
                  _: 1
                }), _createVNode(_component_b_col, {
                  cols: "12",
                  sm: "4"
                }, {
                  default: _withCtx(() => [_createVNode(_component_b_form_group, null, {
                    default: _withCtx(() => [_cache[38] || (_cache[38] = _createElementVNode("label", {
                      class: "control-label"
                    }, "Password Confirm *", -1)), _createVNode(_component_b_input_group, null, {
                      default: _withCtx(() => [_createVNode(_component_b_form_input, {
                        type: "password",
                        modelValue: _ctx.account.user.password2,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _ctx.account.user.password2 = $event),
                        modelModifiers: {
                          lazy: true
                        },
                        state: !_ctx.$v.account.user.password2.$error,
                        onBlur: _cache[18] || (_cache[18] = $event => _ctx.$v.account.user.password2.$touch()),
                        required: "",
                        placeholder: "New Password Confirm",
                        autocomplete: "new-password"
                      }, null, 8, ["modelValue", "state"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getErrors('user', 'password2', ['sameAsPassword']), err => {
                        return _openBlock(), _createBlock(_component_b_form_invalid_feedback, {
                          key: err.id
                        }, {
                          default: _withCtx(() => [_createTextVNode(_toDisplayString(err), 1)], undefined, true),
                          _: 2
                        }, 1024);
                      }), 128))], undefined, true),
                      _: 1
                    })], undefined, true),
                    _: 1
                  })], undefined, true),
                  _: 1
                })], undefined, true),
                _: 1
              }), _createVNode(_component_b_row, null, {
                default: _withCtx(() => [_createVNode(_component_b_col, null, {
                  default: _withCtx(() => [_createVNode(_component_b_form_checkbox, {
                    modelValue: _ctx.account.user.terms,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => _ctx.account.user.terms = $event),
                    state: !_ctx.$v.account.user.terms.$invalid
                  }, {
                    default: _withCtx(() => [...(_cache[39] || (_cache[39] = [_createTextVNode("I have read, understood, and agree to the ", -1), _createElementVNode("a", {
                      href: "/terms/",
                      target: "_blank"
                    }, "Terms of Use", -1)]))], undefined, true),
                    _: 1
                  }, 8, ["modelValue", "state"])], undefined, true),
                  _: 1
                })], undefined, true),
                _: 1
              }), _createVNode(_component_b_row, null, {
                default: _withCtx(() => [_createVNode(_component_b_col, null, {
                  default: _withCtx(() => [_createVNode(_component_b_form_checkbox, {
                    modelValue: _ctx.account.user.privacy,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => _ctx.account.user.privacy = $event),
                    state: !_ctx.$v.account.user.privacy.$invalid
                  }, {
                    default: _withCtx(() => [...(_cache[40] || (_cache[40] = [_createTextVNode("I have read, understood, and agree to the ", -1), _createElementVNode("a", {
                      href: "/privacy/",
                      target: "_blank"
                    }, "Privacy Policy", -1)]))], undefined, true),
                    _: 1
                  }, 8, ["modelValue", "state"])], undefined, true),
                  _: 1
                })], undefined, true),
                _: 1
              }), _createVNode(_component_b_row, null, {
                default: _withCtx(() => [_createVNode(_component_b_col, null, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    id: "promo",
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => _ctx.account.user.promo = $event)
                  }, null, 512), [[_vModelCheckbox, _ctx.account.user.promo]]), _cache[41] || (_cache[41] = _createElementVNode("label", {
                    class: "form-check-label",
                    for: "promo"
                  }, " I wish to receive email notifications when new videos are uploaded or new live stream events are addded to the network. I also understand that from time to time I may receive newsletters and promotional material from SBN Broadcasting. These email preferences can be changed at any time by accessing the \"my account\" section of the network. ", -1))])], undefined, true),
                  _: 1
                })], undefined, true),
                _: 1
              })], undefined, true),
              _: 1
            })], undefined, true),
            _: 1
          })], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      }), _createVNode(_component_b_row, null, {
        default: _withCtx(() => [_createVNode(_component_b_col, {
          class: "text-center"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createVNode(_component_vue_recaptcha, {
            sitekey: "6Le-L6wZAAAAANrSopXo5MQU4rPseWwOZDndebHd",
            onVerify: $options.handleSuccess,
            onError: $options.handleError,
            style: {
              "text-align": "center"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_Checkbox, {
              style: {
                "display": "inline-block",
                "text-align": "center"
              }
            })], undefined, true),
            _: 1
          }, 8, ["onVerify", "onError"])])], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      }), _createVNode(_component_b_row, {
        class: "mb-5"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_col, {
          class: "text-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_button, {
            onClick: _withModifiers($options.submit, ["prevent"]),
            type: "button",
            class: "subscribe-submit-btn",
            disabled: !_ctx.captcharesponse
          }, {
            default: _withCtx(() => [...(_cache[42] || (_cache[42] = [_createTextVNode(" Subscribe ", -1)]))], undefined, true),
            _: 1
          }, 8, ["onClick", "disabled"]), _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1))], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      })], undefined, true),
      _: 1
    })) : _createCommentVNode("", true)], undefined, true),
    _: 1
  });
}